import React from 'react';
import { Hero } from '@/components/site/Hero';
import { Categories } from '@/components/site/Categories';
import { FeaturedListings, FreshListings } from '@/components/site/Listings';
import { Locations } from '@/components/site/Locations';
import { AppPromo } from '@/components/site/AppPromo';
import { SafetyTips } from '@/components/site/SafetyTips';
import SEO from '@/components/common/SEO';
import {
  AdsterraNativeBanner,
  AdsterraBanner320x50,
  AdsterraSmartlinkPromo,
} from '@/components/ads';

const homepageJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'MemAds',
    url: 'https://memads.in',
    description: "India's premium local marketplace for buying and selling cars, mobiles, electronics, furniture, and more.",
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: 'https://memads.in/listings?search={search_term_string}',
      },
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'MemAds',
    url: 'https://memads.in',
    logo: 'https://memads.in/android-chrome-192x192.png',
    description: "India's trusted online classifieds marketplace for buying and selling used goods locally.",
    foundingDate: '2024',
    areaServed: 'IN',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer support',
      url: 'https://memads.in/contact',
    },
    sameAs: [
      'https://memads.in',
    ],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: 'Popular Categories on MemAds',
    description: 'Browse popular product categories on MemAds classifieds marketplace',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Used Cars & Bikes', url: 'https://memads.in/listings?category=vehicles' },
      { '@type': 'ListItem', position: 2, name: 'Mobile Phones & Electronics', url: 'https://memads.in/listings?category=electronics' },
      { '@type': 'ListItem', position: 3, name: 'Furniture & Home Decor', url: 'https://memads.in/listings?category=furniture' },
      { '@type': 'ListItem', position: 4, name: 'Properties & Rentals', url: 'https://memads.in/listings?category=properties' },
    ],
  },
];

const IndexPage: React.FC = () => {
  return (
    <div className="bg-background">
      <SEO
        canonical="/"
        jsonLd={homepageJsonLd}
        rawTitle
        title="MemAds — India's Premium Local Marketplace"
        description="Buy and sell cars, mobiles, electronics, furniture, and more on India's most trusted classifieds marketplace. Verified sellers, secure chat, and free ad posting."
      />
      <Hero />
      <Categories />
      <AdsterraSmartlinkPromo />
      <FeaturedListings />
      <AdsterraNativeBanner />
      <FreshListings />
      <AdsterraBanner320x50 />
      <Locations />
      <AppPromo />
      <SafetyTips />
    </div>
  );
};

export default IndexPage;
